export default __webpack_public_path__ + "static/media/Kayo_Fragment.993a68cf.png";